import mongoose, { Schema } from 'mongoose';
// tslint:disable-next-line no-var-requires
const commonCurrencies = require('../services/common-currencies.json');

export interface IBaseCurrency {
  name: string;
  code: string;
  symbol: string;
}

export interface IBaseCurrencyDocument extends IBaseCurrency, mongoose.Document {
  _id: never;
}

const baseCurrency = new Schema(
  {
    name: {
      type: String,
      required: true,
    },
    code: {
      type: String,
      required: true,
      enum: Object.keys(commonCurrencies),
    },
    symbol: {
      type: String,
      required: true,
    },
  },
  { _id: false },
);

export default baseCurrency;
